import { useEffect, useState } from 'react'
import { NAVIGATE_EVENT, resolveCurrentPath } from '../utils/router'

export function usePathname() {
  const [pathname, setPathname] = useState(resolveCurrentPath)

  useEffect(() => {
    const update = () => setPathname(resolveCurrentPath())
    window.addEventListener('popstate', update)
    window.addEventListener('hashchange', update)
    window.addEventListener(NAVIGATE_EVENT, update)
    return () => {
      window.removeEventListener('popstate', update)
      window.removeEventListener('hashchange', update)
      window.removeEventListener(NAVIGATE_EVENT, update)
    }
  }, [])

  return pathname
}
